import ModelUtil from '@leverege/model-util'

function create( content = null ) {
  return {
    name : null, 
    displayName : null,
    scope : 'custom', 
    category : null, 
    description : null
  }
}

module.exports = {
  create,
  ...ModelUtil.createAllValue( 'name' ),
  ...ModelUtil.createAllValue( 'displayName' ),
  ...ModelUtil.createAllValue( 'scope' ),
  ...ModelUtil.createAllValue( 'category' ),
  ...ModelUtil.createAllValue( 'description' ),
}
